import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaStar, FaRegStar, FaChevronDown, FaChevronUp, FaPen, FaEye } from "react-icons/fa";
import AddAvis from "./AddAvis";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function Avis({ productId }) {
  const [avis, setAvis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erreur, setErreur] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [showAddAvis, setShowAddAvis] = useState(false);

  useEffect(() => {
    const fetchAvis = async () => {
      try {
        const res = await axios.get(`${apiUrl}/api/avis/product/${productId}`);
        setAvis(res.data || []);
      } catch (err) {
        console.error("Erreur lors du chargement des avis :", err);
        setErreur("Impossible de charger les avis.");
      } finally {
        setLoading(false);
      }
    };

    fetchAvis();
  }, [productId]);

  const renderStars = (note) => {
    return (
      <>
        {[...Array(5)].map((_, i) =>
          i < note ? (
            <FaStar key={i} style={{ color: "#ffc107", marginRight: 2 }} />
          ) : (
            <FaRegStar key={i} style={{ color: "#ccc", marginRight: 2 }} />
          )
        )}
      </>
    );
  };

  const toggleAvis = () => {
    setIsOpen(!isOpen);
  };

  const toggleAddAvis = () => {
    setShowAddAvis(!showAddAvis);
  };

  const handleAvisAdded = (newAvis) => {
    setAvis(prevAvis => [newAvis, ...prevAvis]);
    setShowAddAvis(false);
  };

  if (loading) return <p>Chargement des avis...</p>;
  if (erreur) return <p style={{ color: "red" }}>{erreur}</p>;

  return (
    <>
      <style>{`
        .avis-container {
          margin-top: 2rem;
        }

        .avis-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
          padding: 1rem;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border-radius: 12px;
          border: 1px solid rgba(212, 175, 55, 0.2);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .avis-title {
          font-size: 20px;
          margin: 0;
          font-family: 'Cormorant Garamond', serif;
          color: #2c1810;
        }

        .avis-buttons {
          display: flex;
          gap: 10px;
        }

        .avis-button {
          padding: 8px 16px;
          background: rgba(212, 175, 55, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(212, 175, 55, 0.3);
          border-radius: 8px;
          color: #2c1810;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 14px;
          font-family: 'Cormorant Garamond', serif;
          transition: all 0.3s ease;
        }

        .avis-button:hover {
          background: rgba(212, 175, 55, 0.2);
          transform: translateY(-2px);
        }

        .avis-button.secondary {
          background: rgba(139, 90, 43, 0.1);
          border-color: rgba(139, 90, 43, 0.3);
        }

        .avis-button.secondary:hover {
          background: rgba(139, 90, 43, 0.2);
        }

        .avis-section {
          margin-bottom: 1rem;
          padding: 1.5rem;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border-radius: 12px;
          border: 1px solid rgba(212, 175, 55, 0.2);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        .avis-list {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(20px);
          border-radius: 12px;
          border: 1px solid rgba(212, 175, 55, 0.2);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .avis-empty {
          padding: 2rem;
          text-align: center;
          color: #666;
          font-family: 'Cormorant Garamond', serif;
        }

        .avis-item {
          padding: 1rem;
          border: 1px solid rgba(212, 175, 55, 0.2);
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.05);
          margin-bottom: 1rem;
          backdrop-filter: blur(10px);
          font-family: 'Cormorant Garamond', serif;
        }

        .avis-item-header {
          display: flex;
          align-items: center;
          margin-bottom: 6px;
          flex-wrap: wrap;
          gap: 8px;
        }

        .avis-user-name {
          margin-right: 10px;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
          font-weight: bold;
        }

        .avis-stars {
          display: flex;
        }

        .avis-comment {
          margin: 0;
          color: #2c1810;
          font-family: 'Cormorant Garamond', serif;
          line-height: 1.5;
        }

        @media (max-width: 768px) {
          .avis-header {
            flex-direction: column;
            gap: 1rem;
            text-align: center;
            padding: 1.5rem;
          }

          .avis-title {
            font-size: 18px;
          }

          .avis-buttons {
            flex-direction: column;
            width: 100%;
            gap: 8px;
          }

          .avis-button {
            justify-content: center;
            padding: 10px 16px;
            font-size: 13px;
          }

          .avis-section {
            padding: 1rem;
          }

          .avis-item {
            padding: 0.8rem;
          }

          .avis-item-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
          }

          .avis-user-name {
            margin-right: 0;
            font-size: 14px;
          }

          .avis-stars {
            font-size: 12px;
          }

          .avis-comment {
            font-size: 14px;
          }
        }

        @media (max-width: 480px) {
          .avis-header {
            padding: 1rem;
          }

          .avis-title {
            font-size: 16px;
          }

          .avis-button {
            padding: 8px 12px;
            font-size: 12px;
          }

          .avis-section {
            padding: 0.8rem;
          }

          .avis-item {
            padding: 0.6rem;
          }

          .avis-user-name {
            font-size: 13px;
          }

          .avis-stars {
            font-size: 11px;
          }

          .avis-comment {
            font-size: 13px;
          }
        }
      `}</style>

      <div className="avis-container">
        <div className="avis-header">
          <h2 className="avis-title">
          Avis des clients ({avis.filter(a => a && a.userId).length})
        </h2>
        
          <div className="avis-buttons">
          <button
            onClick={toggleAddAvis}
              className="avis-button"
          >
            <FaPen size={14} />
            Écrire un avis
          </button>

          <button
            onClick={toggleAvis}
              className="avis-button secondary"
          >
            {isOpen ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
            Voir les avis
          </button>
        </div>
      </div>

      {/* Section pour écrire un avis */}
      {showAddAvis && (
          <div className="avis-section">
          <AddAvis productId={productId} onAvisAdded={handleAvisAdded} />
        </div>
      )}

      {/* Section des avis existants */}
      {isOpen && (
          <div className="avis-list">
          {avis.filter(a => a && a.userId).length === 0 ? (
              <div className="avis-empty">
              <FaEye size={24} style={{ marginBottom: "10px", opacity: 0.5 }} />
              <p>Aucun avis pour ce produit.</p>
            </div>
          ) : (
            <div style={{ padding: "1rem" }}>
              {avis
                .filter((a) => a && a.userId)
                .map((a, i) => (
                    <div key={i} className="avis-item">
                      <div className="avis-item-header">
                        <strong className="avis-user-name">
                        {a.userId?.name || "Utilisateur"}
                      </strong>
                        <div className="avis-stars">{renderStars(a.note)}</div>
                    </div>
                      <p className="avis-comment">
                      {a.commentaire}
                    </p>
                  </div>
                ))}
            </div>
          )}
        </div>
      )}
    </div>
    </>
  );
}
